import { FocusedWindow, User } from '@highlight/common'
import { atom, useSetAtom, useAtomValue } from 'jotai'
import { atomWithGlobalState, atomWithGlobalStore } from '@highlight/ipc/jotai'

const lastFocusedWindowAtom = atom<FocusedWindow & { appIcon?: string }>()
const devModeAtom = atomWithGlobalStore<boolean>('settings', 'dev-mode', false)

export const useLastFocusedWindow = () => {
  return useAtomValue(lastFocusedWindowAtom)
}

export const useSetLastFocusedWindow = () => {
  return useSetAtom(lastFocusedWindowAtom)
}

export const useDevMode = () => {
  return useAtomValue(devModeAtom)
}

const userAtom = atomWithGlobalState<User | null>('user', null)
export const useUser = () => {
  return useAtomValue(userAtom)
}
